import PropTypes from 'prop-types';
import React from 'react';
import { InputNumber } from '@sm360/widget-commons-forms';
import { LocaleService } from '@sm360/widget-commons-core-services';

import 'commons-vehicle/Vehicle/components/PaymentOptionFilters/InitialCashDown/InitialCashDown.scss';

const InitialCashDown = ({ initialCashDown, setCashDown, disabled }) => {
    return (
        <div className="listing-used-cash-down target-payment">
            <InputNumber
                min={0}
                step={100}
                onChange={(value) => setCashDown(parseFloat(value))}
                decimalCount={2}
                value={initialCashDown ? initialCashDown.toFixed(2) : '0'}
                label={LocaleService.t('FILTERS.INITIAL_CASHDOWN')}
                showLabel
                lightTheme
                disabled={disabled}
            />
        </div>
    );
};

InitialCashDown.defaultProps = {
    disabled: false,
};

InitialCashDown.propTypes = {
    initialCashDown: PropTypes.number.isRequired,
    setCashDown: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

InitialCashDown.displayName = 'InitialCashDown';

export default InitialCashDown;
